module.exports = __webpack_public_path__ + "static/media/50.90458a05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/50.svg
// module id = 177
// module chunks = 0